export default "__VITE_ASSET__6bbd2a64__"